import { PopupHint, classNames, type PopupHintProps } from '@op/opds.opux';
import { type ReactNode } from 'react';
import styles from './PopupHintWrapper.module.scss';
import LocalizedTextList from '../LocalizedTextList';
import { type AnalyticsPhases, trackAction } from 'api/analytics-api';

interface Props extends PopupHintProps {
  analyticsData?: {
    actionName: string;
    phase: AnalyticsPhases;
  };
  children: ReactNode;
  ariaLabel?: string;
}

const PopupHintWrapper = ({
  analyticsData,
  children,
  className,
  ariaLabel,
  ...rest
}: Props) => {
  return (
    <PopupHint
      label={ariaLabel}
      onClick={() => {
        if (analyticsData) {
          trackAction(analyticsData.actionName, 'button', analyticsData.phase);
        }
      }}
      {...rest}
      className={classNames(styles.popupHintWrapper, className)}
      popupHintProps={{
        className: styles.popupContent,
        'data-testid': 'popup-hint-content',
      }}>
      {children}
    </PopupHint>
  );
};

/**
 * Popup paragraphs component. Use for content inside PopupHintWrapper component if
 * more than one paragraph is needed.
 *
 * @param children
 * @constructor
 */
export const PopupParagraphs = ({ texts }: { texts: string[] | undefined }) => (
  <LocalizedTextList
    texts={texts}
    as='span'
    itemClassName={styles.popupParagraph}
  />
);

export default PopupHintWrapper;
